<template>
  <div class="home">
    <el-container>
      <el-header class="header">
        <h1>DYin清理工具</h1>
      </el-header>
      <el-row :gutter="24">
        <el-col :span="14">
          <el-col class="header-box" :offset="1">功能区</el-col>  
          <el-row :gutter="24">
            <el-col :span="24" :offset="1">
              <el-form
                ref="formRef"
                :model="formData"
                :rules="rules"
                label-width="120px"
                class="form-container"
              >
                <el-form-item label="Session ID" prop="sessionId">
                  <div class="form-item-container">
                    <el-input
                      class="setSessionId"
                      v-model="formData.sessionId"
                      placeholder="例如：ac0dd52525cb4839b1865cee8cf697ea"
                    />
                    <el-button class="testBtn" type="primary" @click="handleIsRun(formData.sessionId) ? '':testClearLike()" :loading="handleIsRun(formData.sessionId)">
                      {{ handleIsRun(formData.sessionId) ? "清理中..." : "开始测试" }}
                    </el-button>
                    <el-button class="testlog" type="primary" @click="testLogOpen">查看进度</el-button>
                  </div>
                  <div class="form-item-container">
                    <el-button id="getSessionIdButton" type="text" @click="acquisitionMethod.open()">如何获取Session ID</el-button>
                    <div style="color: red;float: right;">测试只能测试清理1000个喜欢，清理之前请登录网页端确定数量</div>
                  </div>
                </el-form-item>
                <el-form-item label="卡密" prop="cardCode">
                  <div class="form-item-container">
                    <el-input
                      class="setcardCode"
                      v-model="formData.cardCode"
                      placeholder="请输入卡密"
                    />
                  </div>
                  <div class="form-item-container" style="color: #409eff;">
                    <!-- <el-link type="primary" href="tencent://message/?uin=2020129199&Site=&Menu=yes" target="_blank">如何获取卡密</el-link> -->
                    联系管理员获取卡密：QQ：2020129199
                  </div>
                </el-form-item>
                <el-form-item label="清理类型" prop="clearType" class="selectClearType">
                  <el-radio-group v-model="formData.clearType">
                    <el-radio
                      v-for="type in clearTypes"
                      :key="type.value"
                      :label="type.value"
                    >
                      {{ type.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-button class="addBtn" type="primary" @click="submitForm">添加</el-button>
                  <el-button @click="resetForm">重置</el-button>
                  <el-button type="success" @click="goToExcel" class="excel-btn">
                    🔑 卡密格式化工具
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" :offset="1" class="taskList">
              <div class="data-header">任务列表</div>
              <el-table
                :data="tableData"
                border
                style="width: 100%; margin-top: 20px"
                class="table-box"
              >
                <el-table-column label="账号信息">
                  <template #default="scope">
                    <span>昵称：{{ scope.row.nickname }}</span
                    >， <span>DYin号：{{ scope.row.unique_id }}</span
                    >， <span>喜欢数量：{{ scope.row.favoriting_count }}</span
                    >， <span>关注数量：{{ scope.row.follower_count }}</span
                    >， <span>公开作品数量：{{ scope.row.aweme_count }}</span
                    >，
                    <span
                      >私密作品数量：{{ scope.row.private_aweme_count }}</span
                    >
                    <el-button
                      type="primary"
                      size="small"
                      style="margin-left: 10px"
                      :disabled="!canUpdate"
                      @click="updateUserInfofun(scope.row)"
                      >{{
                        canUpdate ? "更新" : `${countdown}秒后可重试`
                      }}</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="sessionId" label="sessionId">
                  <template #default="scope">
                    <span>{{ scope.row.sessionId }}</span>
                    <el-button
                      type="primary"
                      size="small"
                      style="margin-left: 10px"
                      @click="updateUserSessionIdOpen(scope.row)"
                      >更新</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="cardCode" label="卡密" />
                <el-table-column prop="clearType" label="清理类型">
                  <template #default="scope">
                    {{
                      clearTypes.find(
                        (type) => type.value === scope.row.clearType
                      )?.label
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间">
                  <template #default="scope">
                    {{ new Date(scope.row.create_time).toLocaleString() }}
                    <font color="red">卡密将在24小时候后过期</font>
                  </template>
                </el-table-column>
                <el-table-column label="清理日志" style="width: 200px">
                  <template #default="scope">
                    <div v-if="logData[scope.row.cardCode]">
                      <div
                        v-for="(item, index) in logData[scope.row.cardCode]"
                        :key="index"
                      >
                        <div
                          :style="
                            item.type === 'SUCCESS'
                              ? 'color:green'
                              : item.type === 'ERROR'
                              ? 'color:red'
                              : item.type === 'close'
                              ? 'color:blue'
                              : ''
                          "
                        >
                          {{ item.data }}
                        </div>
                      </div>
                    </div>
                    <div v-else>暂无日志</div>
                  </template>
                </el-table-column>
                <el-table-column prop="clearType" label="操作" width="180">
                  <template #default="scope">
                    <el-button
                      type="primary"
                      size="small"
                      @click="
                        handleIsRun(scope.row.cardCode) ? '' : handleClear(scope.row)
                      "
                      :loading="handleIsRun(scope.row.cardCode)"
                    >
                      {{ handleIsRun(scope.row.cardCode) ? "清理中..." : "开始清理" }}
                    </el-button>
                    <el-button
                      v-if="!handleIsRun(scope.row.cardCode)"
                      size="small"
                      type="danger"
                      @click="handleDel(scope.row)"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9" :offset="1" style="position: relative">
          <div class="header-box">常见问题</div>
          <el-collapse style="margin-top: 20px" v-model="activeNames" @change="handleChange">
            <el-collapse-item
              :name="item.id"
              v-for="(item, index) in QuestionsList"
              :key="index"
            >
              <template #title>
                <span class="faq-title">{{ item.title }}</span>
              </template>
              <div style="text-align: left">
                {{ item.content }}
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="shengming-box">本网站只是一个开源工具，提供大家学习交流，不以任何盈利为目的，如有侵权<el-link style="font-size: 12px;vertical-align: baseline;" type="primary" href="tencent://message/?uin=2020129199&Site=&Menu=yes" target="_blank">联系管理员</el-link>下架</div>
        </el-col>
      </el-row>
    </el-container>
    <acquisition-method ref="acquisitionMethod" />
    <!-- 添加SessionId输入弹窗 -->
    <el-dialog v-model="dialogVisible" title="输入Session ID" width="30%">
      <el-input v-model="tempSessionId" placeholder="请输入Session ID" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="updateUserSessionId"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 测试进度弹窗 -->
    <el-dialog v-model="logDialogVisible" title="测试进度" width="50%">
      <div v-if="logData[formData.sessionId]">
        <div
          v-for="(item, index) in logData[formData.sessionId]"
          :key="index"
        >
          <div
            :style="
              item.type === 'SUCCESS'
                ? 'color:green'
                : item.type === 'ERROR'
                ? 'color:red'
                : item.type === 'close'
                ? 'color:blue'
                : ''
            "
          >
            {{ item.data }}
          </div>
        </div>
      </div>
      <div v-else>暂无日志</div>
    </el-dialog>
    <el-dialog v-model="mobileDialogVisible" title="提示" width="80%" :show-close="false" :close-on-click-modal="false">
  <div style="text-align: center;">
    <p>请使用电脑浏览器访问本页面https://douyin.softinstall.top/#/如果没有电脑可以添加下方管理员QQ帮忙清理</p>
    <el-button type="primary" @click="copyUrl">复制网址</el-button>
    <el-button type="primary" @click="addadminqq">添加管理员QQ2020129199</el-button>
  </div>
</el-dialog>

  </div>
</template>

<script setup>
import { ref, reactive, onUnmounted, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElLoading } from "element-plus";
import { getfaqList, LoginInfo, updateSessionId, updateUserInfo } from "@/api/apis";
import AcquisitionMethod from "@/components/AcquisitionMethod.vue";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const router = useRouter();

const driverObj = driver({
  showProgress: true,
  allowClose: true,
  nextBtnText: "下一步",
  prevBtnText: "上一步",
  doneBtnText: "完成",
  steps: [
    { element: '#getSessionIdButton', popover: { title: '第一步，获取 Session ID', description: '点击按钮获取 Session ID', side: "bottom", align: 'start' }},
    { element: '.setSessionId', popover: { title: '输入Session ID', description: '把登录后获取到的sessionid填入输入框内', side: "bottom", align: 'start' }},
    { element: '.testBtn', popover: { title: '是否测试', description: '在没有卡密之前您也可以先测试一下，不过测试只能清理喜欢且只能清理1000条', side: "bottom", align: 'start' }},
    { element: '.testlog', popover: { title: '查看测试清理进度', description: '在这里你可以点击【查看进度】查看你测试清理的进度和日志', side: "bottom", align: 'start' }},
    { element: '.setcardCode', popover: { title: '输入卡密', description: '输入您的卡密，没有的话可以联系客服要一个', side: "bottom", align: 'start' }},
    { element: '.selectClearType', popover: { title: '选择清理类型', description: '在下面勾选出您要清理的业务类型，一个卡密只能选择一种类型', side: "bottom", align: 'start' }},
    { element: '.addBtn', popover: { title: '添加任务', description: '点击添加任务，任务会自动添加到任务列表中', side: "bottom", align: 'start' }},
    { element: '.taskList', popover: { title: '任务列表', description: '任务列表会显示当前添加的任务，并且可以点击【开始清理】按钮开始清理', side: "bottom", align: 'start' }},
  ]
});


const logDialogVisible = ref(false);
const testLogOpen = () => {
  logDialogVisible.value = true;
};


const activeNames = ref(['1'])
const handleChange = (val) => {
  console.log(val)
}

const acquisitionMethod = ref(null);

const formRef = ref(null);
const formData = ref({
  sessionId: "",
  cardCode: "",
  clearType: "",
});

const rules = {
  sessionId: [{ required: true, message: "请输入Session ID", trigger: "blur" }],
  cardCode: [{ required: true, message: "请输入Card Code", trigger: "blur" }],
  clearType: [{ required: true, message: "请选择清理类型", trigger: "change" }],
};

// 从localStorage初始化数据
const tableData = ref(JSON.parse(localStorage.getItem("tableData")) || []);
const clearTypes = [
  { label: "清理喜欢", value: "unlike" },
  { label: "清理收藏", value: "uncollection" },
  { label: "清理推荐", value: "unrecommend" },
  // { label: "清理关注(全部取消)", value: "unfollowall" },
  // { label: "清理关注(保留互关)", value: "unfollowone" },
  // { label: "清理全部互动消息(除了发出的评论，发出的弹幕)", value: "456" },
  { label: "清理互动消息(赞与收藏)", value: "499" },
  { label: "清理互动消息(提及)", value: "601" },
  { label: "清理互动消息(收到的评论)", value: "44" },
  { label: "清理互动消息(收到的弹幕)", value: "520" },
];
// 监听数据变化，保存到localStorage
const saveToLocalStorage = () => {
  // 创建数据的深拷贝
  let data = JSON.parse(JSON.stringify(tableData.value));
  // 将过滤后的数据保存到localStorage
  localStorage.setItem("tableData", JSON.stringify(data));
};

const submitForm = () => {
  formRef.value?.validate(async (valid) => {
    if (valid) {
      const loading = ElLoading.service({
        lock: true,
        text: "正在获取用户信息...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let params = {
          sessionId: formData.value.sessionId,
          cardCode: formData.value.cardCode,
          clearType: formData.value.clearType,
        };

        LoginInfo(params)
          .then((response) => {
            let { status_code, message, data } = response?.data;
            if (status_code == 200) {
              tableData.value.unshift({
                ...formData.value,
                ...data,
              });
              console.log(
                {
                  ...formData.value,
                  ...data,
                },
                "粗腰村的数据"
              );

              saveToLocalStorage(); // 保存到localStorage
              formRef.value?.resetFields();
              ElMessage.success("添加成功");
            } else {
              if (status_code == 400) {
                let msg = `卡密已被使用，DYin名：${data?.nickname}，DYin号：${data?.unique_id}`;
                ElMessage.error(msg || "添加失败");
              } else {
                ElMessage.error(message || "添加失败");
              }
            }
          })
          .finally(() => {
            loading.close();
          });
      } catch (error) {
        ElMessage.error(error.response?.data?.message || "请求失败");
        loading.close();
      }
    } else {
      ElMessage.error("请填写完整信息");
      return false;
    }
  });
};

const resetForm = () => {
  formRef.value?.resetFields();
};
const logData = reactive({});
let socket = "";
// 运行的方法
const Run = (row, type = "否") => {
  // socket = new WebSocket("ws://118.25.133.116:3004/socket");
  // socket = new WebSocket("ws://127.0.0.1:3004/socket");
  socket = new WebSocket("wss://douyin.softinstall.top/socket");
  socket.onopen = () => {
    if (row?.customType == 'test') {
      socket.send(
        JSON.stringify({
          command: 'test.js',
          args: {
            sessionId: row?.sessionId,
            clearType: row?.clearType,
          },
        })
      );
    } else {
      socket.send(
        JSON.stringify({
          command: `douyin3.js`,
          args: {
            cardCode: row?.cardCode,
            clearType: row?.clearType,
            type,
          },
        })
      );
    }
  };

  socket.onmessage = (event) => {
    // 处理从服务器接收到的消息
    let data = event.data ? JSON.parse(event.data) : event.data;
    // 判断logData对象里是否包含某个字段
    if (logData.hasOwnProperty(data.threadName)) {
      // 替换logData[data.threadName]中跟当前data的type一样的数据
      let findIndex = logData[data.threadName].findIndex(
        (e) => e.type === data.type
      );
      if (findIndex !== -1) {
        logData[data.threadName].splice(findIndex, 1, data);
      } else {
        logData[data.threadName].push(data);
      }
    } else {
      logData[data.threadName] = [data];
    }
  };
};

const logDialogDataFun = (id) => {
  const data = reactive(logData[id] || []);
  return data;
};
// 处理是否在运行的函数
const handleIsRun = (threadName) => {
  const data = reactive(logData[threadName] || []);
  if (data.length) {
    if (
      data.some((item) => item.type === "close") ||
      data.some((item) => item.type === "ERROR")
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

const handleClear = (row) => {
  if (row?.cardCode) {
    logData[row?.cardCode] = [];
    Run(row);
  } else {
    ElMessage.error("卡密不能为空");
  }
};

const handleStop = (row) => {
  socket.send(
    JSON.stringify({
      command: "stop",
      type: "ERROR",
      threadName: row?.cardCode,
      data: "已暂停",
    })
  );
};

const handleDel = (row) => {
  // 从tableData中过滤掉要删除的数据
  tableData.value = tableData.value.filter(
    (item) => item.cardCode !== row.cardCode
  );
  // 更新localStorage
  saveToLocalStorage();
  ElMessage.success("删除成功");
};

const countdown = ref(0);
const canUpdate = ref(true);

const updateUserInfofun = (row) => {
  if (!canUpdate.value) {
    ElMessage.warning("请等待倒计时结束");
    return;
  }
  updateUserInfo({
    cardCode: row.cardCode,
  }).then((response) => {
    let { status_code, message, data } = response?.data;
    if (status_code == 200) {
      // 找到要更新的数据索引
      const index = tableData.value.findIndex(
        (item) => item.cardCode === row.cardCode
      );
      if (index !== -1) {
        // 更新数据
        tableData.value[index] = {
          ...tableData.value[index],
          ...data,
        };
        // 保存到localStorage
        saveToLocalStorage();
      }
      ElMessage.success("更新成功");

      // 开始倒计时
      canUpdate.value = false;
      countdown.value = 10;
      const timer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
          clearInterval(timer);
          canUpdate.value = true;
        }
      }, 1000);
    } else {
      ElMessage.error(message || "更新失败");
    }
  });
};

// 添加弹窗相关的响应式变量
const dialogVisible = ref(false);
const tempSessionId = ref("");
const currentRow = ref(null);

const updateUserSessionIdOpen = (row) => {
  currentRow.value = row;
  dialogVisible.value = true;
};

const updateUserSessionId = (row) => {
  if (!tempSessionId.value) {
    ElMessage.warning("请输入Session ID");
    return;
  }

  const loading = ElLoading.service({
    lock: true,
    text: "正在获取用户信息...",
    background: "rgba(0, 0, 0, 0.7)",
  });
  try {
    let data = {
      newSessionId: tempSessionId.value,
      cardCode: currentRow.value?.cardCode,
    };

    updateSessionId(data)
      .then((response) => {
        console.log(response, "responseresponseresponse");

        let { status_code, message, data } = response?.data;
        if (status_code == 200) {
          // 找到要更新的数据索引
          const index = tableData.value.findIndex(
            (item) => item.cardCode === currentRow.value?.cardCode
          );
          if (index !== -1) {
            // 更新数据而不是添加新数据
            tableData.value[index] = {
              ...tableData.value[index],
              sessionId: tempSessionId.value,
              ...data,
            };
            saveToLocalStorage(); // 保存到localStorage
          }
          ElMessage.success("更新成功");
          dialogVisible.value = false;
          tempSessionId.value = "";
          currentRow.value = null;
        } else {
          ElMessage.error(message || "添加失败");
        }
      })
      .finally(() => {
        loading.close();
      });
  } catch (error) {
    ElMessage.error(error.response?.data?.message || "请求失败");
    loading.close();
  }
};


const QuestionsList = reactive([]);
let page = ref(1)
let limit = ref(10)
let keyword = ref("")
const getfaqListFun = () => {
  let params = {
    page: page.value,
    limit: limit.value,
    // keyword: keyword.value
  };

  getfaqList(params).then((response) => {
    let { status_code, message, data } = response?.data;
    if (status_code == 200) {
      let { list, total } = data
      QuestionsList.length = 0  // 清空数组
      QuestionsList.push(...list)  // 将新数据添加到数组中
    } else {
      ElMessage.error(message || "添加失败");
    }
  });
};


// 测试清理喜欢的方法
const testClearLike = () => {
  // formData.sessionId不能为空
  console.log(formData.value.sessionId);
  
  if (!formData.value?.sessionId) {
    ElMessage.error("请输入sessionId");
    return;
  }
  let row = {
    sessionId: formData.value.sessionId,
    clearType: "unlike",
    customType: "test"
  }
  Run(row);
};

// 添加移动端检测和复制功能
const mobileDialogVisible = ref(false);

const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const copyUrl = () => {
  const url = 'https://douyin.softinstall.top/#/';
  navigator.clipboard.writeText(url).then(() => {
    ElMessage.success('网址已复制');
  });
};
const addadminqq = () => {
  const url = '2020129199';
  navigator.clipboard.writeText(url).then(() => {
    ElMessage.success('管理员QQ已复制');
  });
};

const goToExcel = () => {
  router.push('/excel');
};

onMounted(() => {
  getfaqListFun();
  if (isMobile()) {
    mobileDialogVisible.value = true;
  } else {
    driverObj.drive();
  }
});
onUnmounted(() => {
  canUpdate.value = true;
  countdown.value = 0;
});
</script>

<style scoped>
.home {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f5 100%);
}

.header {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: white;
  text-align: center;
  line-height: 70px;
  box-shadow: 0 4px 20px rgba(24, 144, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.form-container {
  margin-top: 24px;
  padding: 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.form-item-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.form-item-container .el-input {
  flex: 1;
  min-width: 200px;
}

.setSessionId {
  flex: 2;
}

.setcardCode {
  flex: 1;
}

.testBtn,
.testlog,
.addBtn,
.excel-btn {
  padding: 12px 24px;
  font-size: 14px;
  border-radius: 8px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  font-weight: 500;
}

.testBtn:hover,
.testlog:hover,
.addBtn:hover,
.excel-btn:hover {
  background: linear-gradient(135deg, #096dd9 0%, #1890ff 100%);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.excel-btn {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
}

.excel-btn:hover {
  background: linear-gradient(135deg, #85ce61 0%, #67c23a 100%);
  box-shadow: 0 6px 16px rgba(103, 194, 58, 0.4);
}

.data-header {
  font-weight: 600;
  margin-top: 24px;
  font-size: 18px;
  color: #303133;
  padding-bottom: 12px;
  border-bottom: 3px solid #1890ff;
  display: inline-block;
  position: relative;
}

.data-header::before {
  content: '📋';
  margin-right: 8px;
}

.table-box {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.header-box {
  font-weight: 600;
  margin-top: 24px;
  font-size: 20px;
  color: #303133;
  padding-bottom: 12px;
  border-bottom: 3px solid #1890ff;
  display: inline-block;
  position: relative;
}

.header-box::before {
  content: '🔧';
  margin-right: 8px;
}

:deep(.el-collapse) {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(24, 144, 255, 0.1);
}

:deep(.el-collapse-item__header) {
  background: #fff;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

:deep(.el-collapse-item__header:hover) {
  background: #f5f7fa;
  color: #1890ff;
}

:deep(.el-collapse-item__wrap) {
  background: #fff;
  border-bottom: none;
}

:deep(.el-collapse-item__content) {
  padding: 20px;
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  background: #fafafa;
}

.faq-title {
  font-weight: 600;
  color: #303133;
}

.shengming-box {
  margin-top: 24px;
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f5 100%);
  border-radius: 12px;
  font-size: 13px;
  color: #606266;
  line-height: 1.8;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(24, 144, 255, 0.1);
}

:deep(.el-dialog) {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

:deep(.el-dialog__header) {
  color: white;
  padding: 20px 24px;
  border-bottom: none;
}

:deep(.el-dialog__title) {
  font-weight: 600;
  font-size: 18px;
}

:deep(.el-dialog__body) {
  padding: 24px;
}

:deep(.el-button--primary) {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  border: none;
  font-weight: 500;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

:deep(.el-button--primary:hover) {
  background: linear-gradient(135deg, #096dd9 0%, #1890ff 100%);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

:deep(.el-button--danger) {
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

:deep(.el-button--danger:hover) {
  box-shadow: 0 6px 16px rgba(245, 108, 108, 0.4);
}

:deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
}

:deep(.el-input__wrapper:hover) {
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

:deep(.el-radio__label) {
  font-size: 14px;
  color: #606266;
}

:deep(.el-radio.is-checked .el-radio__label) {
  color: #1890ff;
  font-weight: 500;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: #1890ff;
  border-color: #1890ff;
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}

:deep(.el-form-item) {
  margin-bottom: 24px;
}

:deep(.el-link) {
  font-weight: 500;
}

:deep(.el-link--primary) {
  color: #1890ff;
}

:deep(.el-link--primary:hover) {
  color: #096dd9;
}

:deep(.el-table) {
  border-radius: 12px;
  overflow: hidden;
}

:deep(.el-table__header-wrapper .el-table__cell) {
  color: white !important;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%) !important;
}

:deep(.el-table__header th) {
  background: transparent !important;
  color: white !important;
  font-weight: 600;
  font-size: 14px;
}

:deep(.el-table__body tr) {
  transition: background-color 0.3s ease;
}

:deep(.el-table__body tr:hover > td) {
  background-color: #f5f7fa !important;
}

:deep(.el-table__body td) {
  padding: 16px 0;
  font-size: 14px;
  color: #303133;
}
</style>
